import { render, staticRenderFns } from "./DeleteData.vue?vue&type=template&id=207905b4"
import script from "./DeleteData.vue?vue&type=script&lang=js"
export * from "./DeleteData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports